const availableSensors = [
    "battery_voltage",
    "soil_1_meter",
    "soil_2_meter",
    "soil_3_meter",
    "leaf_meter",
    "hum_meter",
    "temp_meter",
    "rain_meter",
    "gauge_meter"
]


export function getAvailableSensors() {
    return availableSensors;
}

function extractHeadersFromListOfProcessedData(listOfProcessedData, listOfSensors, context) {
    const headers = ['datetime']
    for (const sensor of listOfProcessedData[0].processed.sensors_data) {
        if (listOfSensors.includes(sensor.measure)) {
            const header = context.$t('sensors.' + sensor.measure)
            headers.push(header)
        }
    }
    return headers;
}

function mapHeaderToTranslatedHeader(header, context) {
    return context.$t('sensors.' + header)

}



export function parseListOfProcessedData(listOfProcessedData, listOfSensors, context) {
    /* listOfSensors should include one or some of the following sensors:
            "battery_voltage",
            "soil_1_meter",
            "soil_2_meter",
            "soil_3_meter",
            "leaf_meter",
            "hum_meter",
            "temp_meter",
            "rain_meter",
            "gauge_meter"
    */
    const parsedData = [];
    for (const d of listOfProcessedData) {
        const datetime = new Date(d.processed.data_measured_datetime);
        const sensorsData = [];
        for (const sensor of d.processed.sensors_data) {
            if (listOfSensors.includes(sensor.measure)) {
                const value = standardizeSoilMoistureProbes(sensor)
                sensorsData.push(value)
            }
        }
        sensorsData.unshift(datetime)
        parsedData.push(sensorsData);
    }
    const headers = extractHeadersFromListOfProcessedData(listOfProcessedData, listOfSensors, context)
    parsedData.unshift(headers)
    return parsedData;
}

export function parseListOfProcessedDataSplit(listOfProcessedData, listOfSensors, context) {
    /* Returns an array with the series split */
    const parsedData = {
        datetime: {
            name: "datetime",
            dataset: []
        }
    }
    for (const sensor of listOfSensors) {
        parsedData[sensor] = {
            name: mapHeaderToTranslatedHeader(sensor, context),
            dataset: []
        }
    }

    for (const d of listOfProcessedData) {
        const datetime = new Date(d.processed.data_measured_datetime);

        for (const sensor of d.processed.sensors_data) {
            if (listOfSensors.includes(sensor.measure)) {
                const value = standardizeSoilMoistureProbes(sensor)

                parsedData[sensor.measure].dataset.push(value)
            }
        }
        parsedData.datetime.dataset.push(datetime)
    }
    return parsedData


}

// function unflattenSoilMoistureProbes(sensor) {
//     var offset = 0;
//     switch (sensor.measure) {
//         case "soil_1_meter": {
//             offset = 1000;
//             break;
//         }
//         case "soil_2_meter": {
//             offset = 500;
//             break;
//         }
//         default: {
//             offset = 0;
//         }
//     }
//     return sensor.value + offset;
// }

function standardizeSoilMoistureProbes(sensor) {
    const standarizationCoefficients = [
        2.154, 3.898e-3, 2.278e-6, 4.824e-10
    ]
    let data = sensor.value;
    if (sensor.measure.includes("soil_")) {
        data = (standarizationCoefficients[3] * Math.pow(data, 3)) -
            (standarizationCoefficients[2] * Math.pow(data, 2)) +
            (standarizationCoefficients[1] * data) -
            standarizationCoefficients[0]
        if(data < 0){
            data = 0;
        }
    }
    return data;
}